/* tslint:disable */
/* eslint-disable */
export enum WorkUseremploymentGavType {
  GavGebaeudetechnik = 'GAV_GEBAEUDETECHNIK',
  GavHolzbau = 'GAV_HOLZBAU',
  GavElektro = 'GAV_ELEKTRO',
  GavGeruestbau = 'GAV_GERUESTBAU',
  GavMetallbau = 'GAV_METALLBAU'
}
